import dateFormat from 'dateformat';
import inx from 'inx';
import { MAIL, MAIL_SYSTEM_DIRS as MSD } from '../config';
import punycode from 'punycode/';

export const extractAddresses = (data, headersList, excludedEmail) => {
    return headersList.reduce((prev, curr) => {
        const emlList = data[curr]
            .filter((item) => item.address !== excludedEmail)
            .map((item) => item.address);

        return [...prev, ...emlList];
    }, []);
};

const getOccupiedHeaderNames = ((headersList) => (data, excluded) => {
    const headersListFiltered = typeof excluded === 'string'
        ? headersList.filter((item) => item !== excluded)
        : headersList;

    return headersListFiltered.filter((item) => {
        const value = data[item];
        return value?.length > 0;
    });
})(MAIL.get('HEADER_NAMES'));

export const parseEmlData = (data, opts) => {
    const { excludedGroup, userEmail } = opts;
    const headersList = getOccupiedHeaderNames(data, excludedGroup);
    const emlsList = extractAddresses(data, headersList);
    const addressList = headersList.reduce((prev, curr) => prev[curr] = {
        ...prev,
        [curr]: data[curr]
    }, {});
    let sentToUser;

    if (headersList.includes('to')) {
        sentToUser = data.to.find((item) => item.address === userEmail);
    }

    return { addressList, emlsList, headersList, sentToUser, userEmail };
};

export const getFormattedDate = (timestamp, format) => dateFormat(timestamp, format);

export const getAddressName = (obj = {}, nameOnly = false) => {
    // console.log(obj);
    const trimmed = {};

    if (Object.keys(obj).length < 1) return trimmed;

    Object.keys(obj).forEach((key) => {
        trimmed[key] = obj[key] === 'string' ? obj[key].trim() : obj[key];
    });

    return nameOnly
        ? trimmed?.personal || punycode.toUnicode(trimmed?.address)
        : trimmed;
};

// MAIL-5663 - check when user show Reply All or Reply button
export const shouldShowReplyAll = ({ toList = [], ccList = [], currentFolder }) => {
    // Combine all visible recipients (To and CC)
    const visibleRecipients = [...toList, ...ccList].map(addr => addr.address.toLowerCase());
    const myEmail = inx.params.user.email;
    // Check if the current user is in the visible recipient list
    const isVisible = visibleRecipients.includes(myEmail.toLowerCase());
    // No one is visible — likely BCC only
    if (visibleRecipients.length === 0) return true;
    // without sent folder
    if (currentFolder !== MSD.SENT) {
        // User is not visible in To or CC — likely received via BCC
        if (!isVisible) return true;
    }
    // There are multiple visible recipients — show "Reply All"
    if (visibleRecipients.length > 1) return true;
    // Only one visible recipient and it's the user — just "Reply"
    return false;
};
export const isUndisclosed = ({ address }) => {
    if (address.trim().length < 1) return false;

    const regex = /^(undisclosed[\s-]?recipients)/i;

    return regex.test(address);
};

export const removeExcluded = (list, exclude) => {
    // console.log(list, exclude);
    if (!exclude) return list;

    if (typeof exclude === 'string') {
        return list.filter((item) => item !== exclude);
    }

    if (Array.isArray(exclude) && exclude.length > 0) {
        return list.filter((item) => !exclude.includes(item));
    }

    return list;
};
